export class Messages {
  MN0005 = '* Campo de preenchimento obrigatório!';
  MN0006 = ' Dados validados e inseridos com sucesso!';
  MN0007 = ' Houve um erro na inclusão dos dados!';
  MN0008 = ' Falha ao comunicar com o serviço.';
  MN0011 = ' Falha na geração do relatório.';
  MN0017 = '* Data informada menor que a data atual';
  MN0023 = ' O registro foi excluído com sucesso !';
  MN0034 = '* Deve conter de 3 a 30 caracteres.';
  MN0040 = ' Selecione a etapa de apuração.';
  MN0041 = ' Não há etapas de apuração com pendência de cadastro de critérios!';
  MN0042 = ' Não há registros carregados para serem salvos!';
  MN0047 = ' A instituição foi regularizada com sucesso!';
  MN0049 = ' Não há dados de credor na base do FIPLAN para a instituição!';
  MN0050 = ' A instituição encontra-se como EXCLUÍDA na base de dados! Deseja recadastrá-la?';
  MN0051 = ' Dados atualizados com sucesso!';
  MN0052 = ' Deseja imprimir no formato para publicação da premiação?';
   MN0055 = ' Ativação da Instituição não permitida! Cadastro não validado pela secretaria responsável.';
  MN0056 = ' Ao validar o cadastro da instituição, a mesma será considerada como ATIVA. Confirma a validação?';
  MN0058 = ' Informe um CNPJ válido !';
  MN0059 = ' Informe um E-mail válido ! ';
  MN0060 = ' Informe um CPF válido !';
  MN0061 = ' Data inválida: Maior que a data atual !';
  MN0062 = ' Data de aprovação menor que a data de solicitação do cadastro!';
  MN0063 = ' Data de solicitação do cadastro maior que a data de aprovação!';
  MN0064 = ' Quantidade de leitos do SUS deve ser no mínimo 70% da quantidade total de leitos.';
  MN0065 = ' Uma instituição enquanto excluída, somente poderá voltar a participar do programa após recadastramento. Confirma a exclusão?';
  MN0066 = ' Existem campos obrigatórios não preenchidos na aba {0:U}. Favor verificar.';
  MN0067 = ' Existem dados bancários pendentes de preenchimento. Confirma o cadastro da instituição com esta pendência?';
  MN0068 = ' Existem campos obrigatórios para a identificação da instituição pendentes de preenchimento ou inválidos. Favor verificar.';
  MN0069 = ' Situação da instituição alterada para REGULAR!';
  MN0070 = ' Cadastro pendente de validação!';
  MN0071 = ' Não foram encontrados na base do FIPLAN informações de pagamentos para o ano de exercício atual!';
  MN0072 = ' Não há registros a serem exibidos!';
  MN0073 = ' Já consta envio do PED referente a etapa de apuração selecionada!';
  MN0074 = ' Já consta envio do EMP com os dados exibidos!';
  MN0075 = ' Já consta envio do LIQ com os dados exibidos!';
  MN0076 = ' As instituições premiadas e com situação regular foram disponibilizadas para o envio do PED!';
  MN0077 = ': Quantidade mínima de habitantes não poderá ser diferente de (0) zero.';
  MN0078 = ': Quantidade mínima de habitantes é maior/igual que a quantidade máxima!';
  MN0079 = ': Quantidade máxima de habitantes é menor/igual que a quantidade mínima!';
  MN0080 = ': Quantidade mínima de habitantes não sequenciada em relação à faixa anterior!';
  MN0081 = ' Não existem critérios de premiação cadastrados para esta etapa. Favor verificar!';
  MN0082 = ' Ocorreu um erro na geração do relatório do resultado de premiação.';
  MN0083 = ' Ocorreu um erro na geração do relatório para publicação do resultado.';
  MN0085 = ' Falha no encerramento/processamento da Etapa de Apuração!';
  MN0086 = ' Houve um erro na exclusão dos dados!';
  MN0087 = ' Houve um erro na atualização dos dados!';
  MN0088 = ' Não há dados para exibição do relatório!';
  MN0089 = ' Não há dados para exibição do arquivo!';
  MN0090 = ' Não há dados para geração do arquivo.'
  MN0091 = ' O registro foi alterado com sucesso !';
 }



// WEBPACK FOOTER //
// ./src/app/shared/helpers/mensages.ts